import { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import * as accountService from '../../../services/accountService'
import styles from './ManageProfile.module.css'
import HoverButton from '../../../components/Miscellaneous/HoverButton'
import LoadingSpinner from '../../../components/Miscellaneous/LoadingSpinner'

const ManageProfile = ({ user, updateMessage }) => {
    const navigate = useNavigate()
    // State
    const [loaded, setLoaded] = useState(false)
    const [account, setAccount] = useState(false)
    const [formData, setFormData] = useState(
        {
            id: null,
            organization: null,
            userName: null,    
            firstName: null,
            lastName: null,
        }
    )

    const handleChange = e => {
        updateMessage('')
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        })
    }
    const createRequestBody = async () => {

        let requestBody =
        {
            "id": `${formData.id}`,
            "organization": `${formData.organization}`,
            "userName": `${formData.userName}`,
            "firstName": `${formData.firstName}`,
            "lastName": `${formData.lastName}`,
        }
        return await requestBody;
    }
    const handleSubmit = async e => {
        e.preventDefault()
        const getReqBody = await createRequestBody()
        try {
            await accountService.addUpdateAccount(getReqBody)
            navigate('/Index')
        } catch (err) {
            updateMessage(err.message)
        }
    }

    const isFormInvalid = () => {
        return (!formData.firstName || !formData.lastName || !formData.organization || !formData.userName)
    }
    const fetchAccount = async () => {
        let foundAccount = await accountService.getAccountByUsername(user.email);
        if (foundAccount) {
            setAccount(foundAccount)
            //updating React state you must create shallow copies of all state (and nested state) that you are updating.
            setFormData({
                ...formData,
                ['id']: foundAccount.id,
                ['organization']: foundAccount.organization,
                ['userName']: foundAccount.userName,
                ['firstName']: foundAccount.firstName,
                ['lastName']: foundAccount.lastName,
            })
        }
        setLoaded(true);
    }
    
    useEffect(() => {
        fetchAccount();
    }, [])


    return (
        <>
            {loaded ?
                <div className={styles.templateIndex}>
                    <h1>Manage Profile Settings</h1>
                    <h2>Assign client and events to account.</h2>
                    <form
                        autoComplete="off"
                        onSubmit={handleSubmit}
                    >
                        <div >
                            <label htmlFor="userName" className={styles.label}>User Name: </label>
                            <br />
                            <input
                                type="text"
                                autoComplete="off"
                                id="userName"
                                value={formData.userName}
                                name="userName"
                                disabled="true"
                            />
                        </div>

                        <div >
                            <label htmlFor="firstName" className={styles.label}>First Name: </label>
                            <br />
                            <input
                                type="text"
                                autoComplete="off"
                                id="firstName"
                                value={formData.firstName}
                                name="firstName"
                                onChange={handleChange}
                            />
                        </div>
                        <div >
                            <label htmlFor="lastName" className={styles.label}>Last Name: </label>
                            <br />
                            <input
                                type="text"
                                autoComplete="off"
                                id="lastName"
                                value={formData.lastName}
                                name="lastName"
                                onChange={handleChange}
                            />
                        </div>
                        <div >
                            <label htmlFor="organization" className={styles.label}>Organization: </label>
                            <br />
                            <input
                                type="text"
                                autoComplete="off"
                                id="organization"
                                value={formData.organization}
                                name="organization"
                                onChange={handleChange}
                            />
                        </div><br />
                        <div>
                            <button disabled={isFormInvalid()} className='button' style={{ marginRight: '20px' }} >
                                Save Changes
                            </button>
                            <Link to="/">
                                <button>Cancel</button>
                            </Link>
                        </div>
                    </form>

                </div>
                :
                <LoadingSpinner />
            }
            <br /><br />
            <button id={styles.backButton} onClick={() => navigate(-1)}> Back </button>
        </>
    );
}

export default ManageProfile;
